import React from "react"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { Form, FormSelect, FormSelectOption } from "@carrotfertility/carotene-core-x"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { StepButtons } from "#/components/carrot-card-cost-share/steps/shared/StepButtons"

export interface SelectStepProps {
  title: string
  description?: React.ReactNode
  selectName: string
  options: FormSelectOption[]
  onSubmit: (formValues: { [key: string]: string }) => void
  defaultValue?: string
}

export function SelectStep({
  title,
  description,
  selectName,
  options,
  onSubmit,
  defaultValue
}: SelectStepProps): JSX.Element {
  const { back } = useStateMachine()

  return (
    <Box>
      <Typography id={`${selectName}-title`} variant="h3" sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.sm })}>
        {title}
      </Typography>

      {description}

      <Form onSubmit={onSubmit} defaultValues={defaultValue ? { [selectName]: defaultValue } : undefined}>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: theme.tokens.spacing.xl,
            marginBlockStart: theme.tokens.spacing.xl
          })}
        >
          <FormSelect name={selectName} aria-labelledby={`${selectName}-title`} options={options} required />

          <StepButtons selectName={selectName} back={back} />
        </Box>
      </Form>
    </Box>
  )
}
